import { ConfigDTO } from "@shared/dto/ConfigDTO";
import Config from "../config";

const baseURL = Config.api.root;

export async function getConfigs(): Promise<ConfigDTO> {
  const response = await fetch(`${baseURL}/api/config`, {
    credentials: "include"
  });
  return response.json();
}
